import styled, { StyledProps } from 'styled-components/macro';

export type TableStylesProps = StyledProps<{}>;

export const TableActions = styled.div`
  position: relative;
`;

export const Dot = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #0076c0;
  margin-left: 3px;
  &:first-child {
    margin-left: 0;
  }
`;

export const Dots = styled.div`
  padding: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
`;

export const ActionsWrapper = styled.div`
  position: absolute;
  top: 15px;
  left: 50%;
  width: 81px;
  background-color: #fff;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  transform: translateX(-50%);
  border-radius: 4px;
  border: 0.5px solid #d8d8d8;
  padding: 2px;
  z-index: 2;
`;

export const ActionsItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 28px;
  border-radius: 3px;
  transition: 0.2s;
  padding: 0 8px;
  margin-bottom: 3px;
  cursor: pointer;
  &:hover {
    background: rgba(0, 118, 192, 0.05);
    box-shadow: inset 0px 0px 4px #d0ecff;
  }
  &:last-child {
    margin-bottom: 0;
    &:before {
      display: none;
    }
  }
  &:before {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 8px;
    right: 8px;
    border-top: 1px solid rgba(216, 216, 216, 0.5);
  }
`;

export const ActionsItemIcon = styled.div`
  margin-right: 10px;
`;

export const ActionsItemText = styled.div`
  color: #0076c0;
  font-size: 13px;
`;
